import { render } from '../core/app.js';
import { S } from '../core/estado.js';

/* =====================================================================
   SUBIDA DE FICHEROS
   ===================================================================== */
export function sugerirTipo(nombre){
  const n = nombre.toLowerCase();
  if(/\.(jpe?g|png|heic|webp|gif)$/.test(n)) return 'Foto';
  if(n.includes('pedido')) return 'Pedido';
  if(n.includes('albar')) return 'Albarán';
  if(n.includes('parte')) return 'Parte de trabajo';
  if(n.includes('factura')) return 'Factura';
  if(n.includes('pliego')) return 'Pliego';
  if(n.includes('acta')) return 'Acta';
  if(n.includes('certificad')) return 'Certificado';
  return 'Otro';
}
export function procesarFicheros(files, cid, pedido=null){
  // Se guarda el File real (no solo su nombre) porque hace falta para subirlo
  // de verdad a R2 cuando se confirme en el modal de clasificar documentos.
  const ficheros = [...files].slice(0,12).map(f=>({
    file:f, nombre:f.name, tam:f.size, sugerido:sugerirTipo(f.name),
    url: f.type.startsWith('image/') ? URL.createObjectURL(f) : null
  }));
  if(!ficheros.length) return;
  S.modal = {t:'documento', c:cid, ficheros, pedido};
  render();
}
window.soltarFicheros = function(e, cid){
  e.preventDefault();
  e.currentTarget.classList.remove('activa');
  procesarFicheros(e.dataTransfer.files, cid);
};
export function conectarSubidaFicheros(){
  document.getElementById('subida').addEventListener('change', e=>{
    procesarFicheros(e.target.files, +e.target.dataset.c, e.target.dataset.p?+e.target.dataset.p:null);
    e.target.value = '';
  });
}

